export const INCOMEIQUEUE_RCM_NETWORK_TYPES = {
  IN_NETWORK: 'in_network',
  OUT_OF_NETWORK: 'out_of_network',
  SELF_PAY: 'self_pay'
};

export const INCOMEIQUEUE_RCM_NETWORK_TABS = [
  { value: INCOMEIQUEUE_RCM_NETWORK_TYPES.IN_NETWORK, label: 'In-network' },
  { value: INCOMEIQUEUE_RCM_NETWORK_TYPES.OUT_OF_NETWORK, label: 'Out-of-network' },
  { value: INCOMEIQUEUE_RCM_NETWORK_TYPES.SELF_PAY, label: 'Self pay' }
];

export const INCOMEIQUEUE_RCM_SCENARIO_FIELDS = {
  OVER_PAYMENT: 'over_payment',
  UNDER_PAYMENT: 'under_payment'
};

export const INCOMEIQUEUE_RCM_ACTION_VALUES = {
  REFUND_PATIENT: 'refund_patient',
  APPLY_CREDIT: 'apply_credit',
  CHARGE_CAP_SAME_INVOICE: 'charge_cap_same_invoice',
  CHARGE_CAP_SEPARATE_INVOICE: 'charge_cap_separate_invoice'
};

export const INCOMEIQUEUE_RCM_SCENARIOS = [
  {
    field: INCOMEIQUEUE_RCM_SCENARIO_FIELDS.OVER_PAYMENT,
    label: 'If the final portion is less than the GFE'
  },
  {
    field: INCOMEIQUEUE_RCM_SCENARIO_FIELDS.UNDER_PAYMENT,
    label: 'If exceeds cap'
  }
];

export const INCOMEIQUEUE_RCM_ACTION_OPTIONS = {
  [INCOMEIQUEUE_RCM_SCENARIO_FIELDS.OVER_PAYMENT]: [
    { value: INCOMEIQUEUE_RCM_ACTION_VALUES.REFUND_PATIENT, label: 'Refund the patient' },
    {
      value: INCOMEIQUEUE_RCM_ACTION_VALUES.APPLY_CREDIT,
      label: 'Apply credit'
    }
  ],
  [INCOMEIQUEUE_RCM_SCENARIO_FIELDS.UNDER_PAYMENT]: [
    {
      value: INCOMEIQUEUE_RCM_ACTION_VALUES.CHARGE_CAP_SAME_INVOICE,
      label: 'Charge up to the cap and invoice above on the same invoice'
    },
    {
      value: INCOMEIQUEUE_RCM_ACTION_VALUES.CHARGE_CAP_SEPARATE_INVOICE,
      label: 'Charge up to the cap and send a separate invoice'
    }
  ]
};

const buildDefaultNetworkScenarios = () =>
  INCOMEIQUEUE_RCM_SCENARIOS.reduce((acc, { field }) => {
    acc[field] = INCOMEIQUEUE_RCM_ACTION_OPTIONS[field]?.[0]?.value ?? null;
    return acc;
  }, {});

export const DEFAULT_INCOMEIQUEUE_RCM = {
  [INCOMEIQUEUE_RCM_NETWORK_TYPES.IN_NETWORK]: buildDefaultNetworkScenarios(),
  [INCOMEIQUEUE_RCM_NETWORK_TYPES.OUT_OF_NETWORK]: buildDefaultNetworkScenarios(),
  [INCOMEIQUEUE_RCM_NETWORK_TYPES.SELF_PAY]: buildDefaultNetworkScenarios()
};

export const hydrateNetworkScenarios = (persisted, networkType) => {
  const stored = persisted?.[networkType] || {};
  return INCOMEIQUEUE_RCM_SCENARIOS.reduce((acc, { field }) => {
    const fallback = INCOMEIQUEUE_RCM_ACTION_OPTIONS[field]?.[0]?.value ?? null;
    acc[field] = stored[field] ?? fallback;
    return acc;
  }, {});
};
